'use client';

import { IEquatable } from '@websolutespa/bom-core';
import { useEffect, useRef, useState } from 'react';

export type Sorting<T> = {
  items: T[];
  sort?: IEquatable;
};

export function useSorting<T>(items_: T[], callback_: (items: T[], sort?: IEquatable) => T[], sort_?: IEquatable) {

  const [sort, setSort] = useState(sort_);
  // const items = callback_(items_.slice(), sort);
  const [items, setItems] = useState(callback_(items_.slice(), sort));

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setSort(sort_);
      setItems(callback_(items_.slice(), sort_));
    }
  }, [items_, sort_]);

  function doSort(sort?: IEquatable) {
    setSort(sort);
    setItems(callback_(items_.slice(), sort));
  }

  return { items, sort, setSort: doSort };
}
